<button class="selected" (click)="showDropDown = true">
  <p class="btn-text">{{ dataValue }}</p>
  <img src="../../../../assets/svgs/arrow_down.svg" class="icon-arrow"
   [ngClass]="{'icon-revert': showDropDown}" alt="icon">
</button>
<ul class="dropdown-list" *ngIf="showDropDown">
  <li *ngFor="let location of list">
    <a (click)="setIdioma.emit({ index: indexList, location: location }); showDropDown = false">
      <p>{{ location }}</p>
    </a>
  </li> 
</ul>